import {
    createTheme as createMuiTheme,
    responsiveFontSizes,
} from "@mui/material/styles";
import type { Direction, Theme } from "@mui/material";
import { baseThemeOptions } from "./base-theme-options";
import { darkThemeOptions } from "./dark-theme-options";
import { lightThemeOptions } from "./light-theme-options";
import { newShade } from "../utils/helpers";

interface Neutral {
    50: string;
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
}

declare module "@mui/material/styles" {
    interface Palette {
        neutral?: Neutral;
    }

    interface PaletteOptions {
        neutral?: Neutral;
    }
}

interface ThemeConfig {
    direction?: Direction;
    mode?: "light" | "dark";
    primary: string;
    text: string;
    fontFamily?: string;
}

export const createTheme = (config: ThemeConfig): Theme => {
    const themeOpts =
        config.mode === "dark" ? darkThemeOptions : lightThemeOptions;

    return responsiveFontSizes(
        createMuiTheme(
            baseThemeOptions,
            {
                ...themeOpts,
                palette: {
                    ...themeOpts.palette,
                    primary: {
                        ...themeOpts.palette?.primary,
                        main: config.primary,
                        light: newShade(config.primary, 20),
                        dark: newShade(config.primary, -20),
                    },
                    primaryText: {
                        ...themeOpts.palette?.primaryText,
                        main: config.text,
                    },
                },
            },
            {
                direction: config.direction,
            },
        ),
    );
};
